import { usePlatformUpdate } from '@reapitform/hooks'

export const useDefaultSpecialConditionDelete = (id: string) => {
  const path: string = `/api/Organization/DefaultSpecialCondition/${id}`

  const [deleteSpecialCondition, isLoading, returnData, isSuccess, isError] = usePlatformUpdate<undefined, any>({
    path: path,
    method: 'DELETE',
    headers: {},
    errorMessage: 'Failed to delete the special condition template',
    successMessage: 'Special condition template is successfully deleted',
  })

  return { deleteSpecialCondition, returnData, isLoading, isSuccess, isError }
}
